import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    userAttendanceData: [], 
}

const userAttendanceSlice = createSlice({
  name: "userAttendance",
  initialState: initialState,
  reducers: {
    setUserAttendanceData(state, value) {
      state.userAttendanceData = value.payload;
    }
  },
});

export const { setUserAttendanceData } = userAttendanceSlice.actions;

export default userAttendanceSlice.reducer;